import dynamic from 'next/dynamic';
const CampaignTeaserVariant3Component = dynamic(() => import('../../molecules/CampaignTeaserVariant3'));
const CampaignTeaserVariant1Component = dynamic(() => import('../../molecules/CampaignTeaserVariant1'));
const CampaignTeaserVariant2Component = dynamic(() => import('../../molecules/CampaignTeaserVariant2'));
const ProductListingVariant1Component = dynamic(() => import('../../molecules/ProductListingVariant1'));
const MagazinIntroCampaignComponent = dynamic(() => import('../../molecules/MagazineIntroCampaignComponent'));
const SearchHomePageComponent = dynamic(() => import('../../molecules/SearchHomePageComponent'));
const OfferOfTheMonthComponent = dynamic(() => import('../../molecules/OfferOftheMonthComponent'));
const SpareAndRepairShopHomePageComponent = dynamic(
  () => import('../../molecules/SpareandRepairshopHomepageComponent'),
);
const SpareAndRepairShopCategorypageComponent = dynamic(
  () => import('../../molecules/SpareandRepairshopcategoryComponent'),
);
const Trust1MadeInGermanyComponent = dynamic(() => import('../../molecules/TrustOneMadeInGermanyComponent'));
const MagazinIntroComponent = dynamic(() => import('../../molecules/MagazineIntroComponent'));
const CategoryHeadlineComponent = dynamic(() => import('../../molecules/CategoryHeadlineComponent'));
const ProductCategoryMainImageComponent = dynamic(() => import('../../molecules/ProductCategoryMainImageComponent'));
const IntroTextComponent = dynamic(() => import('../../molecules/IntroTextComponent'));
const CampaignTextComponent = dynamic(() => import('../../molecules/CampaignTextComponent'));
const ProductNameMainAttributeComponent = dynamic(() => import('../../molecules/ProductNameMainAttributeComponent'));
const SingleProductImagesComponent = dynamic(() => import('../../molecules/SingleProductImageComponent'));
const TrustedShopRatingComponent = dynamic(() => import('../../molecules/TrustedShopRatingComponent'));
const SalesSupportComponent = dynamic(() => import('../../molecules/SalesSupportComponent'));
const OrderActionItemsComponent = dynamic(() => import('../../molecules/OrderActionItemsComponenet'));
const SingleProductPriceShippingInfoComponent = dynamic(
  () => import('../../molecules/SingleProductPriceShippingInfoComponent'),
);
const SalesConfiguratorComponent = dynamic(() => import('../../molecules/SalesConfiguratorComponenet'));
const BraCalculatorComponent = dynamic(() => import('../../molecules/BraCalculatorComponent'));
const MagazinIntroPdpComponent = dynamic(() => import('../../molecules/MagazineIntroPdpcomponent'));
const MagazineArticleListing = dynamic(() => import('../../molecules/MagazineArticleListing'));
const MultiCategorySelectorComponent = dynamic(() => import('../../molecules/Multicategoryselectorcomponent'));
const RecipeArticleListing = dynamic(() => import('../../molecules/RecipeArticleListing'));
const ProductListingVariant2Component = dynamic(() => import('../../molecules/ProductListingvariantComponet2'));
const TopOfferMultiTeaserComponent = dynamic(() => import('../../molecules/top-offer-multiteaser'));
const CampaignSingleOfferComponent = dynamic(() => import('../../molecules/CampaignSingleOfferComponent'));
const TopServiceCategoryTeaserComponent = dynamic(() => import('../../molecules/top-service-category-teaser/'));
const ProductListingVariant4Component = dynamic(() => import('../../molecules/ProductListingVairant4'));
const CategoryOfferOfTheMonthComponent = dynamic(() => import('../category-cook/CategoryOfferOfTheMonthComponent'));
const HighLightsData = dynamic(() => import('frontastic/tastics/product-information/HighlightsComponent'));
const ProductLongDescriptionComponent = dynamic(
  () => import('frontastic/tastics/product-information/ProductLongDescriptionComponent'),
);
const BonusProduct = dynamic(() => import('frontastic/tastics/bonus-product'));
const BonusProductsModule = dynamic(() => import('../../molecules/bonus-product'));
const TvUpsellProductsModules = dynamic(() => import('../../molecules/tv-upsell-product'));
const ShopsRating = dynamic(() => import('components/genius-ui/molecules/TrustedShopRatingpart2'));
const Faqs = dynamic(() => import('frontastic/tastics/faqs'));
const SpareAndRepairShopPdpComponent = dynamic(() => import('../pdp/SpareAndRepairShopPdpComp'));
const MagazineSubCategory = dynamic(() => import('../../molecules/MagazineSubCategory'));
const MagazineMainSlider = dynamic(() => import('../../molecules/MagazineMainSlider'));
const MainMagazineCategory = dynamic(() => import('../../molecules/MainMagazineCategory'));
const MagazineMainHeading = dynamic(() => import('../../molecules/MagazineMainHeading'));
const MagazinFeaturedCategory = dynamic(() => import('../../molecules/MagazineFeaturedCategory'));
const RecipeFeaturedCategory = dynamic(() => import('../../molecules/RecipeFeaturedCategory'));
// const MagazinePosts = dynamic(() => import('../genius-magazine/MagazinMostReadPost'));
const BrandAdvantages = dynamic(() => import('frontastic/tastics/brandAdvantages'));
const Newsletter = dynamic(() => import('frontastic/tastics/newsletter'));
const MagazineSingleArticleComponent = dynamic(() => import('../../molecules/MagazineSingleArticleComponenet'));
const RelatedMagazineArticlesComponent = dynamic(() => import('../../molecules/RelatedMagazineArticlesComponent'));
const RelatedRecipesComponent = dynamic(() => import('../../molecules/RelatedRecipesComponent'));
const MagazineSeoLinksComponent = dynamic(() => import('../../molecules/MagazineSeoLinksComponenet'));
const RelatedProductComponent = dynamic(() => import('../../molecules/RelatedProductComponent'));
const SharePrintComponent = dynamic(() => import('../../molecules/SharePrintComponent'));
const RecipeSingleArticleComponent = dynamic(() => import('../../molecules/RecipeSingleArticleComponent'));
const RecipeOfTheMonthComponent = dynamic(() => import('../../molecules/RecipeOfTheMonthComponent'));
const ProductCategory = dynamic(() => import('../category-cook/ProductCategory'));
const SpecialOfferShopHomeComponent = dynamic(() => import('../../molecules/SpecialOfferHomePageComponent'));
const SpecificFAQComponent = dynamic(() => import('../../molecules/SpecificFaqComponenet'));
const ListingSpecificModule = dynamic(() => import('../../molecules/ListingSpecificModule'));
const SearchMagazineComponent = dynamic(() => import('../../molecules/SearcchMagazineComponent'));
const SearchRecipeComponent = dynamic(() => import('../../molecules/SearchRecipeComponent'));

const BannerImageComponent = dynamic(() => import('../../molecules/BannerImageComponent'));
const CategoryBannerImageComponent = dynamic(() => import('../../molecules/CategoryBannerImageComponent'));
const MagazineProductCategoryComponent = dynamic(() => import('../../molecules/MagazineProductCategoryComponent'));
const RecipeMainSliderComponent = dynamic(() => import('../../molecules/RecipeMainSliderComponent'));
const ProductTechnicalDescriptionComponent = dynamic(
  () => import('frontastic/tastics/product-information/ProductTechnicalDescriptionComponent'),
);
const BrandBrandRoleComponent = dynamic(() => import('../../molecules/BrandBrandRoleComponent'));
const HeadlineComponent = dynamic(() => import('../category-cook/HeadlineComponent'));
const ServiceIntroTextComponent = dynamic(() => import('../../molecules/ServiceIntroTextComponent'));
const ServiceListingShortComponent = dynamic(() => import('../../molecules/ServiceListingShort'));
const SearchServiceCenterComponent = dynamic(() => import('../../molecules/SearchServiceCenterComponent'));
const ContactMultiTeaserComponent = dynamic(() => import('../../molecules/ContactMultiteaserComponent'));
const SearchServiceCenterCategoryComponent = dynamic(
  () => import('../../molecules/SearchServiceCenterCategoryComponent'),
);
const ServiceListingComponent = dynamic(() => import('../../molecules/ServiceListingComponent'));
const ServiceSubCategoryComponent = dynamic(() => import('../../molecules/ServiceSubcategoryComponent'));
const MagazineRecipeComponent = dynamic(() => import('../../molecules/MagazineRecipeComponent'));
const MagazineCategoryMainImageComponent = dynamic(() => import('../../molecules/MagazineCategoryMainImageComponent'));
const MagazineRatingComponent = dynamic(() => import('../../molecules/MagazineRatingComponent'));
const ProductlistingVariant1_1component = dynamic(() => import('../../molecules/ProductListingVariant1_1component'));
const ProductListingVariantComponent2_1 = dynamic(() => import('../../molecules/ProductListingVariant2_1component'));
const ProductListingVariantComponent3 = dynamic(() => import('../../molecules/ProductListingVariant3Component'));
const ServiceOfferMultiteaser = dynamic(
  () => import('../../molecules/ServiceOfferMultiteaser/ServiceOfferMultiteaser'),
);
const VisualTimerComponent = dynamic(() => import('../../molecules/VisualizedTimer'));
const SimpleTextComponent = dynamic(() => import('../../molecules/SimpleTextComponent'));
const MobileMenu = dynamic(() => import('../../organisms/mobile-menu/index'));
const SeoText = dynamic(() => import('../../molecules/SeoTextComponent'));
const SearchHomeTVPageComponent = dynamic(() => import('../../molecules/SearchHomeTvcomponent'));
const SearchCategoryComponent = dynamic(() => import('../../molecules/SearchCategoryComponent'));
const BreadcrumbComponent = dynamic(() => import('../../molecules/BreadCrumpComponent'));
const FaqListingCategoryComponent = dynamic(() => import('../../molecules/FaqListingCategoryComponent'));
const FaqListingGlobalComponent = dynamic(() => import('../../molecules/FaqListingGlobalComponent'));
const SustainabilityTeaserComponent = dynamic(() => import('../../molecules/SustainableTeasetComponent'));

const BrandTeaserComponent = dynamic(() => import('../../molecules/BrandTeaserComponent'));
const ProductPersonInChargeComponent = dynamic(() => import('../../molecules/ProductPersonInCharge'));
const ProductWarningAndSafetyInstruction = dynamic(() => import('../../molecules/ProductWarningAndSafetyInfo'));
const ContactForm = dynamic(() => import('../../molecules/kontaktformular'));
export const TemplatesComponents: any = {
  search_homepage: SearchHomePageComponent,
  offer_of_the_month: OfferOfTheMonthComponent,
  spare_and_repair_shop: SpareAndRepairShopHomePageComponent,
  trust1_madeingermany: Trust1MadeInGermanyComponent,
  magazine_intro: MagazinIntroComponent,
  category_offer_of_the_month: CategoryOfferOfTheMonthComponent,
  product_listing_variant_2: ProductListingVariant2Component,
  top_offer_multiteaser: TopOfferMultiTeaserComponent,
  top_service_category_teaser: TopServiceCategoryTeaserComponent,
  product_listing_category: ProductCategory,
  product_listing_variant_4: ProductListingVariant4Component,
  product_highlights: HighLightsData,
  product_long_description: ProductLongDescriptionComponent,
  bonus_products: BonusProductsModule,
  tv_upsell_products: TvUpsellProductsModules,
  magazine_intro_pdp: MagazinIntroPdpComponent,
  trusted_shops_rating_part2: ShopsRating,
  faq_listing_specific: ListingSpecificModule,
  spare_and_repair_shop_pdp: SpareAndRepairShopPdpComponent,
  spare_and_repair_shop_categories: SpareAndRepairShopCategorypageComponent,
  brand_advantages_branderole: BrandAdvantages,
  newsletter_signup_compact: Newsletter,
  magazine_main_slider: MagazineMainSlider,
  search_magazine: SearchMagazineComponent,
  search_recipe: SearchRecipeComponent,
  magazine_featured_category_multi_teaser: MagazinFeaturedCategory,
  magazine_sub_category_nav_module: MagazineSubCategory,
  magazine_article_listing: MagazineArticleListing,
  recipe_article_listing: RecipeArticleListing,
  magazine_single_article: MagazineSingleArticleComponent,
  related_magazin_articles: RelatedMagazineArticlesComponent,
  related_recipes: RelatedRecipesComponent,
  magazine_seo_links: MagazineSeoLinksComponent,
  related_product: RelatedProductComponent,
  share_print: SharePrintComponent,
  recipe_single_article: RecipeSingleArticleComponent,
  main_magazine_category: MainMagazineCategory,
  magazine_page_heading: MagazineMainHeading,
  // magazine_most_read_post: MagazinePosts,
  genius_magazine_madeingermany: Trust1MadeInGermanyComponent,
  recipe_of_the_month: RecipeOfTheMonthComponent,
  recipe_main_slider: RecipeMainSliderComponent,
  recipe_entry_page_heading: MagazineMainHeading,
  recipe_featured_category_multi_teaser: RecipeFeaturedCategory,
  recipe_product_knowledge: Trust1MadeInGermanyComponent,
  faq_specific: SpecificFAQComponent,
  search_faq: SearchHomePageComponent,
  banner_image: BannerImageComponent,
  category_banner_image: CategoryBannerImageComponent,

  campaign_offer_single: CampaignSingleOfferComponent,
  magazine_product_category: MagazineProductCategoryComponent,
  product_technical_description: ProductTechnicalDescriptionComponent,
  special_offer_slider: SpecialOfferShopHomeComponent,
  brand_branderole: BrandBrandRoleComponent,
  headline_module: HeadlineComponent,
  service_intro_text: ServiceIntroTextComponent,
  service_listing_short: ServiceListingShortComponent,
  search_service_center: SearchServiceCenterComponent,
  contact_multi_teaser: ContactMultiTeaserComponent,
  search_service_center_category: SearchServiceCenterCategoryComponent,
  service_listing: ServiceListingComponent,
  service_subcategory: ServiceSubCategoryComponent,
  magazine_intro_campaign: MagazinIntroCampaignComponent,
  product_listing_variant_1: ProductListingVariant1Component,
  campaign_teaser_variant_2: CampaignTeaserVariant2Component,
  campaign_teaser_variant_3: CampaignTeaserVariant3Component,
  campaign_teaser_variant_1: CampaignTeaserVariant1Component,
  magazine_recipe: MagazineRecipeComponent,
  magazine_sub_category_main_image: MagazineCategoryMainImageComponent,
  magazine_rating: MagazineRatingComponent,
  product_listing_variant_1_1: ProductlistingVariant1_1component,
  product_listing_variant_2_1: ProductListingVariantComponent2_1,
  product_listing_variant_3: ProductListingVariantComponent3,
  category_headline: CategoryHeadlineComponent,
  product_category_main_image: ProductCategoryMainImageComponent,
  intro_text: IntroTextComponent,
  campaign_text: CampaignTextComponent,
  multicategory_selector: MultiCategorySelectorComponent,
  service_offer_multiteaser: ServiceOfferMultiteaser,
  visualized_timer: VisualTimerComponent,
  simple_text: SimpleTextComponent,
  mobile_menu: MobileMenu,
  seo_text: SeoText,
  search_homepage_tv_offer: SearchHomeTVPageComponent,
  search_category: SearchCategoryComponent,
  breadcrumb_service: BreadcrumbComponent,
  faq_listing_category: FaqListingCategoryComponent,
  faq_listing_global: FaqListingGlobalComponent,
  sustainability_teaser: SustainabilityTeaserComponent,
  branded_teaser: BrandTeaserComponent,
  product_name_main_attribute: ProductNameMainAttributeComponent,
  single_product_images: SingleProductImagesComponent,
  trusted_shops_rating_part1: TrustedShopRatingComponent,
  sales_support: SalesSupportComponent,
  order_action_items: OrderActionItemsComponent,
  single_product_price_shipping_info: SingleProductPriceShippingInfoComponent,
  bra_calculator: BraCalculatorComponent,
  sales_configurator: SalesConfiguratorComponent,
  product_person_in_charge: ProductPersonInChargeComponent,
  product_warning_and_safety_instructions: ProductWarningAndSafetyInstruction,
  kontakt_formular: ContactForm,
};
